export default __webpack_public_path__ + "static/media/HHclosed.a4e0d799.mp3";